export default class ThankYou {
    constructor(element) {
      this.el = element;
      this.formId = this.el.querySelector(".contact-form").id;
      this.init();
    }
  
    init() {
      const storedData = sessionStorage.getItem("ec_form_submit");
      if (!storedData) {
        return;
      }
  
      let submissionData;
      try {
        submissionData = JSON.parse(storedData);
      } catch (e) {
        console.error("Error parsing JSON from sessionStorage:", e);
        return;
      }
  
      if (submissionData.formId === this.formId) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(submissionData);
        
  
         sessionStorage.removeItem("ec_form_submit");
      } else {
        console.log(`Stored formId (${submissionData.formId}) does not match this thank-you page formId (${this.formId}).`);
      }
    }
  }
  